import { Typography, Stack, Avatar } from "@mui/material";

export default function ViewImage({ profileImg, stuName }) {

  return (
    <Stack direction="row" spacing={1} className="student-info">
      <Stack direction="column" justifyContent="center">
        <Avatar
          alt={stuName}
          src={profileImg?.slice(0, 5) === "https" ? profileImg : `${process.env.React_App_VIEW_URL}${profileImg}`}
        />
      </Stack>
      <Stack direction="column" justifyContent="center">
        <Typography className="student-name">{stuName}</Typography>
      </Stack>
    </Stack>
  );
}
